<template>
  <div style="height: 100%">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.45">
      <template #main>
        <TableMain name="one table" ref="ConsultQuoteTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="true" :show_toolbar="true" :show_toolbar_state="false" :show_filter="true"
          date_picker_label="创建时间" :query_button_label="query_lable" :isBusy="isBusy"
          :hb_table_class="'hb_table_cqe_class1'" @on_query="on_query" @state_change="state_change"
          :show_toolbar_button="[1, 1, 0, 0, 1]" :table_height_adjust="-6" :only_text="$t('common.show_all')"
          @only_methods="only_methods" @tool_invoke="tool_invoke" @current_changed="current_changed"
          @on_cell_button_click="on_cell_button_click" tableref="08f01eb670c24edd97578be579a5f28b">
          <template #query>
            <el-input clearable size="small" style="width: 200px" placeholder="请输入询价单编号"
              v-model="ConsultQuoteNum"></el-input>
          </template>
          <template #toolbar>
            <el-button type="info" plain @click="createData()" class="ml-2 iconfont icon-add-new" size="mini">
              {{ $t("common.new") }}
            </el-button>
            <el-popover placement="right" title="提示" width="250" trigger="hover" content="默认显示未启用的询价单！"
              style="border-color: red;">
              <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
            </el-popover>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="ConsultQuoteTable2" :show_query_container="false" :show_date_picker="false"
          :fields="consult_apply_fields" :table_height_adjust="8" :title="table_title.title2"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false"
          :pager_count="5" :isBusy="isBusy2" :hb_table_class="'hb_table_cqe_class2'" :loading_width="30"
          :show_toolbar_state="false" tableref="fd626b558d96466c90f1a7245ef47d77">
          <template #toolbar>
            <el-popover placement="right" title="提示" width="250" trigger="hover" content="默认显示没有询过价的申请！"
              style="border-color: red;">
              <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
            </el-popover>
            <div style="display: inline-block">
              <el-checkbox-group style="display: inline-block" class="ml-2" v-model="checkedConditions"
                @change="only_methods_detail">
                <el-checkbox v-for="(item, index) in onlyCheckOptions" :label="item.value" :key="index">{{ item.label
                  }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </template>
          <template #operation>
            <el-button type="info" plain class="ml-2" @click="getInventIntoDetail"><i
                class="iconfont icon-down2"></i>&nbsp;&nbsp;{{ $t("common.selected") }}
            </el-button>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="ConsultQuoteTable3" :fields="detail_fields" :show_query_container="false"
          :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="2"
          :show_pagination="true" :show_filter="false" :pager_count="5" :isBusy="isBusy3" :loading_width="90"
          @state_change="detail_state_change" :show_toolbar_button="[0, 0, 0, 0, 1]"
          :hb_table_class="'hb_table_cqe_class3'" :show_toolbar_state="false" tableref="4c7a5ad0258e42878ca30108dfb0032a">
          <template #toolbar>
            <el-select size="small" v-model="temp_invent_num" filterable remote reserve-keyword
              :remote-method="ItemIdRemoteMethod" clearable @focus="ItemIdRemoteMethod('')"
              @clear="ItemIdRemoteMethod('')" placeholder="请输入物料关键词" class="ml-2" style="width:300px">
              <el-option v-for="(t, k) in InventOptions" :key="k" :label="t.label" :value="t.value"></el-option>
            </el-select>
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="AppendIntoDetail"><i
                class="fa fa-plus"></i></el-button>
          </template>
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="Detail_SaveData"
              :label="$t('common.save')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>
    <!-- 询价单 -->
    <BaseModal ref="QTModal" :title="qt_modal_title" @saveData="SaveData" :width="'35%'">
      <template #modal_content>
        <el-form ref="dataForm" label-width="100px" class="demo-dataForm" style="height: 200px">
          <span v-for="(item, index) in ConsultQuoteModel" :key="index">
            <el-col :span="24">
              <el-form-item :label="item.label" v-if="item.key == 'Description'">
                <el-input type="textarea" v-model="item.value" clearable rows="8"></el-input>
              </el-form-item>
            </el-col>
          </span>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import fixedBaseData from "../../../public/js/fixedBaseData"
import * as InventTableController from "../../controllers/base/InventTableController"
import * as commonController from "../../controllers/commonController"
import * as ConsultQuoteConttroller from "../../controllers/mm/ConsultQuoteConttroller"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import QueryButton from "../components/base/QueryButton"
import SplitContainer3 from "../components/container/SplitContainer3"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    SplitContainer3,
    TableMain,
    BaseModal,
    QueryButton
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_consult_quote",
        title2: "table_consult_quote_application_detail",
        title3: "table_consult_quote_detail",
      },
      fields: _.cloneDeep(ConsultQuoteConttroller.fields.default),
      detail_fields: _.cloneDeep(ConsultQuoteConttroller.fields.detail),
      consult_apply_fields: _.cloneDeep(ConsultQuoteConttroller.fields.application),
      ConsultQuoteModel: [],
      qt_modal_title: "",
      ConsultQuoteNum: "",
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      InventListHis: [],
      filter_invent_name_key: "",
      consult_quote_apply_num: "",
      InventOptions: [],
      temp_invent_num: "",
      all_role_users: [],
      query_date: [],
      hisConsultOrderData: [],
      ConsultQuoteDetailHis: [],
      checkedConditions: [],
      onlyCheckOptions: [
        { value: 1, label: this.$t('common.show_all') },
        { value: 2, label: "仅打样报价" }
      ],
    }
  },
  async created() {
    this.ConsultQuoteModel = _.map(this.fields, (t) => {
      let m = {
        key: t.key,
        label: t.label,
        value: "",
        dataType: "input",
        require: true,
        editable: true,
        seq: 0
      }
      return m
    })
    this.ConsultQuoteModel = _.orderBy(this.ConsultQuoteModel, ["seq"], ["asc"])

    let invalidMainFields = ["is_send_email"]
    this.fields = _.filter(this.fields, (t) => {
      return !_.includes(invalidMainFields, t.key)
    })

    this.consult_apply_fields = _.filter(this.consult_apply_fields, (t) => { delete t.editable; return t })
    let invalidFields = ["id", "is_valid", "Accessory"]
    this.consult_apply_fields = _.filter(this.consult_apply_fields, (t) => {
      return !_.includes(invalidFields, t.key)
    })

    let invalidFieldsDetail = ["Accessory", "DemandDate", "DayDemandQty", "ConsultQuoteNum", "is_send_email", "dataAreaId", "CompanyName"]
    this.detail_fields = _.filter(this.detail_fields, (t) => {
      return !_.includes(invalidFieldsDetail, t.key)
    })

    let f = _.find(this.detail_fields, { key: "TradeMode" })
    f["_options"] = {
      provider: (v) => {
        return _.map(fixedBaseData["TradeMode"], (t) => {
          return {
            value: t.label,
            label: t.label,
          }
        })
      },
    }
    f = _.find(this.detail_fields, { key: "CurrencyCode" })
    f["_options"] = {
      provider: (v) => {
        return _.map(_.uniqBy(this.$store.state.biz_data.baseData.Currency, "CurrencyCode"), (t) => {
          return {
            value: t.CurrencyCode,
            label: t.CurrencyCode + ":" + t.Txt,
          }
        })
      },
    }
    await this.getAllRoleUsers()
  },
  mounted() { },
  methods: {
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    only_methods(v) {
      let dt = this.hisConsultOrderData
      if (!this.$refs.ConsultQuoteTable1.only_value)
        dt = _.filter(this.hisConsultOrderData, { is_valid: false })
      this.$refs.ConsultQuoteTable1.SetData(dt)
    },
    async on_query(set_data, _date, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }

      let p = { is_deleted: { "=": 0 } }
      if (this.ConsultQuoteNum != "") {
        p.ConsultQuoteNum = { like: "%" + this.ConsultQuoteNum + "%" }
      }
      if (_date && _date.length > 0) {
        this.query_date = _date
        let _fromDate = this.$date.format(_date[0], "yyyy-MM-dd")
        let _toDate = this.$date.format(_date[1], "yyyy-MM-dd")
        p["create_at"] = { ">=": _fromDate, "<=": _toDate }
      }

      let _result = await ConsultQuoteConttroller.methods.getData(p)

      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.orderBy(_.cloneDeep(_result[0]), ["id"], ["desc"])
        dt.forEach((t) => {
          let _json = { quotation_task_num: "", cust_name: "", dataAreaIds: "" }
          if (t.fcGetConsultQuoteDetailInfo && t.fcGetConsultQuoteDetailInfo != "")
            _json = JSON.parse(t.fcGetConsultQuoteDetailInfo.replace(/\s+/g, ""))
          t.QuotationTaskNums = _json.quotation_task_num
          t.CustNames = _json.cust_name
          t.dataAreaIds = _json.dataAreaIds
        })
        this.hisConsultOrderData = _.cloneDeep(dt)
        if (!this.$refs.ConsultQuoteTable1.only_value)
          dt = _.filter(dt, { is_valid: false })

        set_data(dt)
      }
      if (isLoading) {
        // 查询询价申请明细
        this.getConsultQuoteData()
      }
      this.isBusy = false
    },

    ///状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        cb(false)
        return
      }
      let p = {}
      if (data.state == "valid" || data.state == "invalid") {
        ///检查是否有明细
        let hasDetail = _.findIndex(data.selected_items, { fcCheckCQIsOk: false }) > -1
        if (hasDetail && data.state == "valid") {
          this.msgToasts("询价单明细未完成，不能启用相关数据！", "info")
          cb(false)
          return
        }
        ///检查是否询价已处理
        if (data.state == "invalid") {
          let isHandle = _.findIndex(data.selected_items, { fcCheckCQHandleIsOk: true }) > -1
          if (isHandle) {
            this.msgToasts("询价单已分配，不能禁用相关数据！", "info")
            cb(false)
            return
          }
        }
        let dt = _.filter(data.selected_items, (t) => { return t.is_valid == !(data.state == "valid") })
        p.edit = _.map(dt, (t) => { return { id: t.id, is_valid: data.state == "valid" } })
      }
      else if (data.state == "deleted") {
        let is_approved = _.some(data.selected_items, ["is_valid", true])
        if (is_approved) {
          this.msgToasts("已启用数据不能被删除！", "info")
          cb(false)
          return
        }
        p.delete = data.selected_items
      }
      let rt = await ConsultQuoteConttroller.methods.saveData(p)
      if (rt) {
        if (data.state == "deleted")
          this.$refs.ConsultQuoteTable1.RemoveItems(rt[0])
        else
          await this.on_query(this.$refs.ConsultQuoteTable1.SetData, this.query_date, false)
        // ///启用时发送邮件
        // if (data.state == "valid")
        //   await this.SendEmail(_.filter(data.selected_items, { is_valid: true }));

        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },

    ///打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    ///新增、编辑
    createData() {
      this.qt_modal_title = "新建询价单"
      _.each(this.ConsultQuoteModel, (t) => {
        switch (t.key) {
          case "Price": t.value = 0; break
          case "BatchQty": t.value = 0; break
          default: t.value = ""
        }
      })
      this.$refs.QTModal.show()
    },
    on_cell_button_click(data) {
      this.qt_modal_title = "编辑询价单"
      for (var k in data.item) {
        let m = _.find(this.ConsultQuoteModel, { key: k })
        if (m) {
          m.value = data.item[k]
        }
      }
      this.$refs.ConsultQuoteTable1.SetCurrentItem(data.item)
      this.$refs.QTModal.show()
    },
    async SaveData(cb) {
      //数据验证
      let msg = "", am = {}, valid_fields = ["dataAreaId"]
      _.each(this.ConsultQuoteModel, (t) => {
        am[t.key] = t.value
        if (msg == "" && _.includes(valid_fields, t.key) && (t.value == "" || !t.value)) {
          msg = t.label + "不能为空！"
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }

      delete am.create_at
      delete am.create_by_username
      delete am.QuotationTaskNums
      delete am.CustNames
      delete am.dataAreaIds
      let p = { add: [], edit: [] }
      if (am.id == "") {
        delete am.id
        p.add.push(am)
      }
      else {
        p.edit.push(am)
      }

      let rt = await ConsultQuoteConttroller.methods.saveData(p)
      if (rt) {
        await this.on_query(this.$refs.ConsultQuoteTable1.SetData, this.query_date, am.id ? false : true)
        cb(true, true)
      }
      else {
        cb(true, false)
      }
    },

    async current_changed(old, current) {
      this.$refs.ConsultQuoteTable3.SetData([])
      if (current) {
        await this.Detail_Query(current.id)
      }
    },
    only_methods_detail(v) {
      let checkedValue = _.last(v)
      this.checkedConditions = [checkedValue]
      let dt = _.cloneDeep(this.ConsultQuoteDetailHis)
      if (checkedValue == 1) { }
      else if (checkedValue == 2) {
        dt = _.filter(dt, { quotationType: "打样报价" })
      }
      else {
        dt = _.filter(dt, { hasConsultOrder: false })
      }

      this.$refs.ConsultQuoteTable2.SetData(dt)
    },
    //查询询价申请明细
    async getConsultQuoteData(isLoading = true) {
      if (isLoading) {
        this.$refs.ConsultQuoteTable2.SetData([])
        this.isBusy2 = true
      }
      let p = { is_valid: { "=": 1 } }
      let _result = await ConsultQuoteConttroller.methods.getDataApply(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.orderBy(_result[0], ["ConsultQuoteApplyNum", "LineNum"], ["desc", "asc"])
        this.ConsultQuoteDetailHis = dt
        this.only_methods_detail()
      }
      this.isBusy2 = false
    },

    ///查询报价明细
    async Detail_Query(QTId, isLoading = true) {
      if (isLoading)
        this.isBusy3 = true

      let p = { ConsultQuoteId: QTId }
      let _result = await ConsultQuoteConttroller.methods.getDetailDataSql(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.orderBy(_result[0], ["LineNum"], ["asc"])
        this.$refs.ConsultQuoteTable3.SetData(dt)
      }
      // let p = { is_deleted: { "=": 0 } }
      // p.ConsultQuoteId = { "=": QTId }
      // let _result = await ConsultQuoteConttroller.methods.getDetailData(p);
      // if (!_.isNull(_result) && _result && _result.length > 0) {
      //   this.$refs.ConsultQuoteTable3.SetData(_.orderBy(_result[0], ["LineNum"], ["asc"]));
      // }
      this.isBusy3 = false
    },
    ///新增明细行
    Detail_CreateData(im) {
      let items_length = this.$refs.ConsultQuoteTable3.my_data.length
      let newItems = [], m = {}
      if (items_length == 0) {
        m["LineNum"] = items_length + 1
      }
      else {
        let last_m = _.last(this.$refs.ConsultQuoteTable3.my_data)
        m["LineNum"] = last_m.LineNum + 1
      }
      if (im) {
        let t = _.find(this.InventOptions, { value: im.ItemId })
        m.TEC_SpecType = im.TEC_SpecType
        m.UnfoldSize = im.UnfoldSize
        if (!im.CostGroupId && t) {
          im.CostGroupId = t.CostGroupId
        }
        m.ItemId = im.ItemId
        m.NameAlias = im.NameAlias
        m.CostGroupId = im.CostGroupId
        m.DW_ItemGroupId = im.DW_ItemGroupId
        m.ConsultQuoteApplyNum = im.ConsultQuoteApplyNum
        m.CustAccount = im.CustAccount
        m.CustName = im.CustName
        m.dataAreaId = im.dataAreaId
        m.FromQty = im.FromBatchQty
        m.ToQty = im.BatchQty
        m.DeliveryAddress = im.DeliveryAddress
        m.DeliveryMode = im.DeliveryMode
        m.TradeMode = "国内贸易"
        m.CurrencyCode = "CNY"
        m.Accessory = im.Accessory
        m.Description = im.Description
        m.QuotationTaskNum = im.QuotationTaskNum
        m.QuotationTaskDetailId = im.QuotationTaskDetailId
        m.quotationType = im.quotationType
      }
      let table1_current = this.$refs.ConsultQuoteTable1.GetCurrentItem()
      if (table1_current) {
        m.id = ""
        m.ConsultQuoteId = table1_current.id
        m.ConsultQuoteNum = table1_current.ConsultQuoteNum
        newItems.push(m)
        this.$refs.ConsultQuoteTable3.AppendItems(newItems)
      }
    },
    ///将选中物料添加到明细
    getInventIntoDetail() {
      let selected_invent_data = this.$refs.ConsultQuoteTable2.GetSelectedItems()
      if (selected_invent_data.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      _.each(selected_invent_data, (t) => {
        this.Detail_CreateData(t)
      })
    },
    ///明细状态切换
    async detail_state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state === "deleted") {
        let table1_current = this.$refs.ConsultQuoteTable1.GetCurrentItem()
        if (table1_current && table1_current.is_valid) {
          this.msgToasts("询价单已启用，不能修改相关明细！", "info")
          cb(false)
          return
        }
        let v = await this.msgModal(this.$t("notify.is_deleted"))

        if (v) {
          let db_del_dt = _.filter(data.selected_items, (t) => { return t.id != "" })
          let del_dt = _.filter(data.selected_items, (t) => { return t.id == "" })
          if (db_del_dt.length > 0) {
            let p = { delete: db_del_dt }
            let rt = await ConsultQuoteConttroller.methods.saveDetailData(p)
            if (rt) {
              this.$refs.ConsultQuoteTable3.RemoveItems(db_del_dt)
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(false)
            }
            else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
          this.$refs.ConsultQuoteTable3.RemoveItems(del_dt)
        }
      }

    },
    ///保存明细
    async Detail_SaveData(cb) {
      //数据验证
      let msg = "", p = { add: [], edit: [] }
      let detail_data = this.$refs.ConsultQuoteTable3.my_data
      if (detail_data.length == 0) {
        cb(null)
        return
      }
      let mainCurrent = this.$refs.ConsultQuoteTable1.GetCurrentItem()
      let require_fileds = _.map(_.filter(this.detail_fields, { required: true }), (t) => { return t })
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        for (var i in require_fileds) {
          let fm = require_fileds[i]
          if (msg == "" && m[fm.key] == "") {
            msg = fm.label + "不能为空！"
          }
        }
        m.ConsultQuoteId = mainCurrent.id
        m.ConsultQuoteNum = mainCurrent.ConsultQuoteNum

        if (m.id == "") {
          delete m.id
          delete m.UnfoldSize
          p.add.push(m)
        }
        else {
          p.edit.push({
            id: m.id,
            FromQty: m.FromQty,
            ToQty: m.ToQty,
            CurrencyCode: m.CurrencyCode,
            DeliveryAddress: m.DeliveryAddress,
            DeliveryMode: m.DeliveryMode,
            TradeMode: m.TradeMode,
            Description: m.Description
          })
        }
      })
      console.log(p)
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      let rt = await ConsultQuoteConttroller.methods.saveDetailData(p)
      if (rt) {
        this.$refs.ConsultQuoteTable1.GetCurrentItem().fcCheckCQIsOk = true
        await this.Detail_Query(this.$refs.ConsultQuoteTable1.GetCurrentItem().id, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    AppendIntoDetail() {
      let im = _.find(this.InventOptions, { value: this.temp_invent_num })
      if (im)
        this.Detail_CreateData(im)
    },
    //#endregion
    //物料名称关键字
    InventInputChanged() {
      let dt = this.InventListHis
      if (this.filter_invent_name_key != "" && dt && dt.length > 0) {
        let keys = this.filter_invent_name_key.split("*")
        let reg = ".*" + _.join(keys, ".*.") + ".*"
        let fdt = _.filter(dt, (t) => {
          if (t.NameAlias.match(reg)) {
            return t
          }
        })
        this.$refs.ConsultQuoteTable2.SetData(fdt)
      }
      else {
        this.$refs.ConsultQuoteTable2.SetData(this.InventListHis)
      }
    },
    ///物料下拉
    async ItemIdRemoteMethod(query) {
      await this.getKvInvent(query)
    },
    ///根据dataAreaId获取物料
    async getKvInvent(query = '') {
      let p = {}
      p.Query = query
      let _result = await InventTableController.methods.getTop100InventKvData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.InventOptions = _.uniqBy(_.map(_result[0], (t) => {
          t.value = t.ItemId
          t.label = t.ItemId + ":" + t.NameAlias
          return t
        }), "ItemId")
      }
    },
    ///发送报价申请处理邮件
    async SendEmail(data) {
      let p = _.map(data, (t) => { return { ConsultQuoteNum: t.ConsultQuoteNum } })
      await commonController.handleEmailNotify(p, "consult_order", this, this.all_role_users, "email_get_consult_data")
    },
  },
}
</script>
<style>
.hb_table_cqe_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 75rem;
}

.hb_table_cqe_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 185rem;
}

.hb_table_cqe_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 135rem;
}
</style>
